import validator from "validator";

export const validateBirth = (birthday: string) => {
  return !validator.isDate(birthday, {
    format: "YYYY-MM-DD",
  });
};
